<div
  *ngIf="isIntegrationOn"
  #integrationFooter
  class="cfb-footer-integration"
  [class.cfb-footer-integration--visible]="isIntegrationFooterVisible"
  [attr.aria-hidden]="!isIntegrationFooterVisible"
>
  <!-- Grey shaded background section -->
  <div class="cfb-footer-links">
    <div class="cfb-footer-links__inner">
      <!-- Contact Us -->
      <div class="cfb-footer-col">
        <p class="cfb-footer-col__heading">
          {{ 'footer.contactUs' | translate }}
        </p>
        <div class="cfb-footer-col__items">
          <div class="cfb-footer-col__item">
            <p class="cfb-footer-col__label">
              {{ 'footer.helpWithReg' | translate }}
            </p>
            <a
              class="cfb-footer-col__link cfb-footer-col__link--phone"
              href="tel:+18002616242"
            >
              {{ 'footer.contactNum' | translate }}
            </a>
            <p class="cfb-footer-col__label">
              {{ 'footer.contactHours' | translate }}
            </p>
          </div>
        </div>
      </div>

      <!-- Resources -->
      <div class="cfb-footer-col">
        <p class="cfb-footer-col__heading">
          {{ 'footer.resources' | translate }}
        </p>
        <div class="cfb-footer-col__items">
          <div class="cfb-footer-col__item">
            <p class="cfb-footer-col__label">Prescription Drug Lists:</p>
            <a
              class="cfb-footer-col__link"
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.cigna.com/individuals-families/member-guide/prescription-drug-lists/#/pdlv"
            >
              <span class="cfb-footer-col__link-text">{{
                'footer.pdl' | translate
              }}</span>
              <cigna-icon
                type="external-link"
                class="cfb-footer-col__ext-icon"
                aria-hidden="true"
              ></cigna-icon>
            </a>
          </div>
          <div class="cfb-footer-col__item">
            <p class="cfb-footer-col__label">Provider Directory</p>
            <a
              class="cfb-footer-col__link"
              target="_blank"
              rel="noopener noreferrer"
              href="https://hcpdirectory.cigna.com/web/public/consumer/directory"
            >
              <span class="cfb-footer-col__link-text">{{
                'footer.provDir' | translate
              }}</span>
              <cigna-icon
                type="external-link"
                class="cfb-footer-col__ext-icon"
                aria-hidden="true"
              ></cigna-icon>
            </a>
          </div>
        </div>
      </div>

      <!-- Other Cigna Websites -->
      <div class="cfb-footer-col">
        <p class="cfb-footer-col__heading">
          {{ 'footer.otherCignaSites' | translate }}
        </p>
        <div class="cfb-footer-col__items">
          <div class="cfb-footer-col__item">
            <p class="cfb-footer-col__label">Main site:</p>
            <a
              class="cfb-footer-col__link"
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.cigna.com/"
            >
              <span class="cfb-footer-col__link-text">{{
                'footer.cignaCom' | translate
              }}</span>
              <cigna-icon
                type="external-link"
                class="cfb-footer-col__ext-icon"
                aria-hidden="true"
              ></cigna-icon>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Dark navy legal section -->
  <div class="cfb-footer-legal">
    <div class="cfb-footer-legal__inner">
      <!-- Copyright -->
      <p class="cfb-footer-legal__copyright" data-test-id="rights-reserved-lbl">
        &copy; {{ currentYear }} {{ 'footer.copyRight' | translate }}
      </p>

      <!-- Legal links — 3 columns -->
      <div class="cfb-footer-legal__links">
        <div class="cfb-footer-legal__links-col">
          <a
            class="cfb-footer-legal__link"
            data-test-id="privacy-link"
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.cigna.com/legal/compliance/privacy-notices"
          >
            <span class="cfb-footer-legal__link-text">{{
              'footer.privacy' | translate
            }}</span>
            <cigna-icon
              type="external-link"
              class="cfb-footer-legal__ext-icon"
              aria-hidden="true"
            ></cigna-icon>
          </a>
          <a
            class="cfb-footer-legal__link"
            data-test-id="legal-disclaimer-link"
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.cigna.com/legal/compliance/terms-of-use"
          >
            <span class="cfb-footer-legal__link-text">{{
              'footer.legalDisclaimer' | translate
            }}</span>
            <cigna-icon
              type="external-link"
              class="cfb-footer-legal__ext-icon"
              aria-hidden="true"
            ></cigna-icon>
          </a>
        </div>
        <div class="cfb-footer-legal__links-col">
          <a
            class="cfb-footer-legal__link"
            data-test-id="security-link"
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.entrust.net/customer/profile?domain=cignaforemployers.cigna.com&lang=en"
          >
            <span class="cfb-footer-legal__link-text">{{
              'footer.security' | translate
            }}</span>
            <cigna-icon
              type="external-link"
              class="cfb-footer-legal__ext-icon"
              aria-hidden="true"
            ></cigna-icon>
          </a>
        </div>
        <div class="cfb-footer-legal__links-col">
          <!-- OneTrust Cookies Settings button start -->
          <a id="ot-sdk-btn" class="ot-sdk-show-settings cfb-footer-legal__link"
            >Cookie Preferences</a
          >
          <!-- OneTrust Cookies Settings button end -->
        </div>
      </div>

      <!-- Subsidiary text -->
      <p class="cfb-footer-legal__subsidiary">
        {{ 'footer.subsidiaryText' | translate }}
      </p>

      <!-- Divider -->
      <hr class="cfb-footer-legal__divider" />

      <!-- Disclaimer -->
      <div class="cfb-footer-legal__disclaimer">
        <cigna-icon
          type="external-link"
          class="cfb-footer-legal__disclaimer-icon"
          aria-hidden="true"
        ></cigna-icon>
        <p>{{ 'footer.disclaimerText' | translate }}</p>
      </div>
    </div>
  </div>
</div>
<div *ngIf="!isIntegrationOn" class="footer-unsecure">
  <div>
    <span class="footer-unsecure-cc">
      &copy; {{ currentYear }}
      {{ 'imperonateTool.copyRight' | translate }}
    </span>
    <span class="footer-unsecure-pp-ll">
      <a
        target="_blank"
        href="https://www.cigna.com/legal/compliance/privacy-notices"
      >
        {{ 'imperonateTool.privacy' | translate }}
        <cigna-icon
          type="external-link"
          class="cg-mat-icon-link-right cg-color-digital-blue f-s-m"
        ></cigna-icon>
      </a>
    </span>
    <span class="footer-unsecure-pp-ll footer-unsecure-pp-ll-divider">
      <a
        target="_blank"
        [href]="'https://www.cigna.com/legal/compliance/disclaimers'"
      >
        {{ 'imperonateTool.legalDisclaimer' | translate }}
        <cigna-icon
          type="external-link"
          class="cg-mat-icon-link-right cg-color-digital-blue f-s-m"
        ></cigna-icon>
      </a>
    </span>
    <span class="footer-unsecure-pp-ll footer-unsecure-cookie">
      <!-- OneTrust Cookies Settings button start -->
      <a id="ot-sdk-btn" class="ot-sdk-show-settings">Cookie Settings</a>
      <!-- OneTrust Cookies Settings button end -->
    </span>
  </div>
</div>
